import {
  resolveTheme,
  ThemeEnum,
  useThemeStore,
} from "@/shared/lib/theme/theme"
import {
  Button,
  cn,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@beringlab/ui"
import { Monitor, Moon, Sun } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const ThemeToggle = () => {
  const { t } = useTranslation()
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)
  const { theme, setTheme } = useThemeStore()

  const themeNavigation = [
    { name: t("common.themeLight"), value: ThemeEnum.Light, Icon: Sun },
    { name: t("common.themeDark"), value: ThemeEnum.Dark, Icon: Moon },
    { name: t("common.themeSystem"), value: ThemeEnum.System, Icon: Monitor },
  ]

  const TriggerIcon = resolveTheme(theme) === ThemeEnum.Dark ? Moon : Sun

  return (
    <Popover open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="plain"
          size="iconLg"
          aria-label={t("common.theme")}
          className={`${isDropdownOpen ? "bg-gray-backdrop-300" : "hover:bg-outline-button-hovered"}`}
        >
          <TriggerIcon size={20} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="mr-3 w-[150px]">
        {themeNavigation.map((item, index) => (
          <button
            key={item.value}
            className={cn(
              item.value === theme && "bg-selected-option",
              "flex w-full items-center gap-x-2 border-none px-4 py-2 text-sm text-default hover:bg-outline-button-hovered",
              index === 0 && "rounded-t-default hover:rounded-t-default",
              index === themeNavigation.length - 1 &&
                "rounded-b-default hover:rounded-b-default"
            )}
            onClick={() => {
              setTheme(item.value)
              setIsDropdownOpen(false)
            }}
          >
            <item.Icon size={16} />
            {item.name}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  )
}

export default ThemeToggle
